import type { MandatoryLabelModalProps } from './components/CLPMandatoryLabelModal';
import type { CLPSubjectHeaderLabelProps } from './components/CLPSubjectHeaderLabel';
import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    LazyAction,
    type LazyComponent,
    LazyImport,
    LazyModule,
} from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "Protection"*/ './lazyIndex'),
    {
        name: 'Protection',
    }
);

export const lazyLoadCLPUserLabels: LazyAction<
    typeof lazyIndex.loadCLPUserLabels,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadCLPUserLabels);
export const lazyGetPendingLoadLabelPromise: LazyAction<
    typeof lazyIndex.getPendingLoadLabelPromise,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getPendingLoadLabelPromise);
export const lazyShowJustificationModal: LazyAction<
    typeof lazyIndex.showJustificationModal,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showJustificationModal);
export const lazyLoadItemCLPInfo: LazyAction<typeof lazyIndex.loadItemCLPInfo, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.loadItemCLPInfo);
export const lazyUpdateItemCLPInfo: LazyImport<
    typeof lazyIndex.updateItemCLPInfo,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.updateItemCLPInfo);
export const lazyLogReadCLPLabel: LazyImport<typeof lazyIndex.logReadCLPLabel, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.logReadCLPLabel);
export const lazyLogCLPLabelChange: LazyAction<
    typeof lazyIndex.logCLPLabelChange,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logCLPLabelChange);
export const lazyShouldShowLouderLabelsMenu: LazyImport<
    typeof lazyIndex.shouldShowLouderLabelsMenu,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.shouldShowLouderLabelsMenu);
export const lazyLoadComplianceConfig: LazyAction<
    typeof lazyIndex.loadComplianceConfig,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadComplianceConfig);
export const CLPSubjectHeaderLabel: LazyComponent<CLPSubjectHeaderLabelProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CLPSubjectHeaderLabel);
export const lazyGetCLPLableFromItem: LazyAction<
    typeof lazyIndex.getCLPLableFromItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getCLPLableFromItem);
export const CLPMandatoryLabelModal: LazyComponent<MandatoryLabelModalProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CLPMandatoryLabelModal);
export const lazyLoadDLPPolicies: LazyAction<typeof lazyIndex.loadDLPPolicies, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.loadDLPPolicies);
export const lazyLoadDLPPoliciesForSecondaryAccounts: LazyAction<
    typeof lazyIndex.loadDLPPoliciesForSecondaryAccounts,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadDLPPoliciesForSecondaryAccounts);
export const lazyHandleAutoLabelingResult: LazyAction<
    typeof lazyIndex.handleAutoLabelingResult,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.handleAutoLabelingResult);
export const lazyClearCLPLabel: LazyAction<typeof lazyIndex.clearCLPLabel, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.clearCLPLabel);
export const lazyGetAttachmentLabels: LazyAction<
    typeof lazyIndex.getAttachmentLabels,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAttachmentLabels);
export const lazyClearAttachmentLabelsCache: LazyAction<
    typeof lazyIndex.clearAttachmentLabelsCache,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.clearAttachmentLabelsCache);
export const lazyTriggerAttachmentLabelInheritance: LazyAction<
    typeof lazyIndex.triggerAttachmentLabelInheritance,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.triggerAttachmentLabelInheritance);
export const lazyGetDefaultCLPLabel: LazyAction<
    typeof lazyIndex.getDefaultCLPLabel,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getDefaultCLPLabel);

export const lazyOpenCollaborationProtectionAgent: LazyAction<
    typeof lazyIndex.openCollaborationProtectionAgent,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openCollaborationProtectionAgent);

export { getCLPLabel } from './selectors/getCLPLabel';
export { default as getComplianceId } from './utils/getComplianceId';
